import React, { FC, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { IMessage } from "src/@types/message";
import { Message } from "./Message";
import "./scrollbar.scss";
import { chatWindowTrns } from "./trns";

interface Props {
  messages: IMessage[];
}

export const MessagesList: FC<Props> = ({ messages }) => {
  const { t } = useTranslation();
  const listRef = useRef(null);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTo({
        top: listRef.current.scrollHeight,
      });
    }
  }, [messages]);

  return (
    <div className="h-125 p-2 bg-white-base/50 rounded-20 xl:max-w-231.5">
      <div
        ref={listRef}
        className="flex flex-col gap-5 p-3 h-full overflow-auto chat-scrollbar"
      >
        {!Boolean(messages.length) && (
          <div className="flex justify-center items-center flex-1 text-22">
            {t(chatWindowTrns.messageListIsEmpty)}
          </div>
        )}

        {messages.map(({ id, ...message }, i) => (
          <Message key={id} {...message}>
            {message.message}
          </Message>
        ))}
      </div>
    </div>
  );
};
